export default __webpack_public_path__ + "static/media/882.0a1aafeb.png";